import React from "react";
import { motion } from "framer-motion";
import { MessageCircle, Phone, Mail, Instagram } from "lucide-react";

const WHATSAPP = "918839790836";
const PHONE = "+918839790836";
const EMAIL = "pulsesupport4@gmail.com";
const INSTA = "pulse.forbusiness";

const fade = {
  hidden: { opacity: 0, y: 18 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.5, delay: i * 0.08 } }),
};

const channels = [
  { icon: MessageCircle, label: "WhatsApp", value: "+91 88397 90836", sub: "Fastest way to reach us", href: `https://wa.me/${WHATSAPP}`, accent: "bg-pulse-green", testid: "contact-whatsapp" },
  { icon: Phone, label: "Call us", value: "+91 88397 90836", sub: "Mon–Sat, 10am–7pm IST", href: `tel:${PHONE}`, accent: "bg-pulse-navy", testid: "contact-call" },
  { icon: Mail, label: "Email", value: EMAIL, sub: "We reply within a day", href: `mailto:${EMAIL}`, accent: "bg-pulse-navy", testid: "contact-email" },
  { icon: Instagram, label: "Instagram", value: `@${INSTA}`, sub: "Behind the scenes & updates", href: `https://instagram.com/${INSTA}`, accent: "bg-gradient-to-br from-pink-500 to-orange-400", testid: "contact-instagram" },
];

export default function ContactUs() {
  return (
    <div className="bg-white" data-testid="contact-page">
      <section className="relative overflow-hidden bg-pulse-navy text-white grain-overlay">
        <div className="relative z-10 mx-auto max-w-3xl px-5 py-20 sm:px-8 sm:py-28">
          <motion.div initial="hidden" animate="show" variants={fade}>
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-pulse-green">Contact Us</span>
            <h1 className="mt-4 text-4xl font-bold leading-[1.1] tracking-tight sm:text-5xl lg:text-6xl">Let's talk.</h1>
            <p className="mt-6 max-w-xl text-lg text-white/60">
              Questions, a demo, or ready to get set up? Reach us on whichever feels easiest — a real person will get back to you.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-5 py-16 sm:px-8 sm:py-20">
        <div className="grid gap-4 sm:grid-cols-2">
          {channels.map((c, i) => (
            <motion.a
              key={c.label}
              href={c.href}
              target={c.href.startsWith("http") ? "_blank" : undefined}
              rel="noopener noreferrer"
              data-testid={c.testid}
              custom={i}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={fade}
              className="group flex items-center gap-4 rounded-xl border border-slate-200 p-5 transition-all hover:-translate-y-0.5 hover:border-pulse-green hover:shadow-pulse-md"
            >
              <div className={`grid h-12 w-12 shrink-0 place-items-center rounded-xl text-white ${c.accent}`}>
                <c.icon size={22} />
              </div>
              <div className="min-w-0">
                <div className="text-xs font-medium uppercase tracking-wide text-slate">{c.label}</div>
                <div className="truncate font-semibold text-pulse-navy">{c.value}</div>
                <div className="text-xs text-slate">{c.sub}</div>
              </div>
            </motion.a>
          ))}
        </div>

        <div className="mt-10 rounded-xl bg-cloud/60 p-6 text-sm text-slate">
          <span className="font-semibold text-pulse-navy">Pulse</span> is a product by <span className="font-semibold text-pulse-navy">Jbros Innovation Pvt. Ltd.</span>, based in Raipur, Chhattisgarh, India.
        </div>
      </section>
    </div>
  );
}
